import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { UsuariosService } from '../../_services/usuarios.service';
import { Table } from 'primeng/table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { Estado } from '../../_models/estado';
import { EstadoBoton } from '../../_models/estado-boton';
import { EstadoService } from '../../_services/estado.service';
import { EstadoBotonService } from '../../_services/estado-boton.service';
import { ListaService } from '../../_services/lista.service';

@Component( {
  selector: 'app-estados-botones',
  templateUrl: 'estados-botones.component.html'
} )

export class EstadosBotonesComponent implements OnInit {

  @Input()
  estado: Estado;
  columnas: any[] = [];
  @ViewChild('dt') t: Table;

  //
  estadosBotones: EstadoBoton[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  cargandoTabla = false;
  botones: any[] = [];
  botonesFiltrados: any[] = [];
  carInformacionInicial = true;

  constructor(
    private route: ActivatedRoute,
    private estadoServicio: EstadoService,
    private usuarioService: UsuariosService,
    private navService: NavService,
    private location: Location,
    private listaService: ListaService,
    private estServicio: EstadoService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private estadoBotonService: EstadoBotonService

) {
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'codigo', header: this.navService.buscarMensaje( 'LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navService.buscarMensaje( 'LBL_NOMBRE' ), sort: true },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.estServicio.obtenerPorId( params[ 'id' ] ).subscribe( estado => {
          this.estado = estado;
          this.listaService.getMasterDetails( 'ListasBotonesEstados' )
            .subscribe( x => x.forEach( y => this.botones.push( { label: y.nombre, value: y.idLista } ) ) );
          if ( this.estado ) {
            this.refrescar();
          }
        } );
      } else {
        this.location.back();
      }
    } );


  }

  get f() {
    return this.formulario.controls;
  }

  cargarFormulario() {
    this.submitted = false;
    this.formulario = this.fb.group( {
      idEstado: [ this.estado.idEstado, [ Validators.required ] ],
      idEstadoBoton: [],
      idBoton: [ null, [ Validators.required ] ]
    } );
  }

  guardar() {
    this.submitted = true;
    if ( this.formulario.invalid ) {
      return;
    }
    this.estadoBotonService.obtenerPorIdEstadoAndIdBoton( this.estado.idEstado, this.f.idBoton.value )
      .subscribe( ( estadoBoton: EstadoBoton ) => {
        if ( estadoBoton ) {
          estadoBoton.indicadorHabilitado = true;
        } else {
          estadoBoton = this.formulario.value;
        }
        if ( !!estadoBoton.idEstadoBoton ) {
          this.estadoBotonService.actualizar( estadoBoton )
            .subscribe( () => {
              this.refrescar();
              this.navService.setMesage( 2,
                {
                  severity: 'info',
                  summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                  detail: this.navService.buscarMensaje( 'ESTADOS.LBL_REGGUAR' )
                } );
            } );
        } else {
          this.estadoBotonService.crear( this.formulario.value )
            .subscribe( () => {
              this.navService.setMesage( 1,
                {
                  severity: 'info',
                  summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                  detail: this.navService.buscarMensaje( 'ESTADOS.LBL_REGGUAR' )
                } );
              this.refrescar();
            } );
        }
      } );
  }

  eliminar( row: EstadoBoton ) {
    row.indicadorHabilitado = false;
    this.estadoBotonService.actualizar( row )
      .subscribe( () => this.refrescar() );
  }

  refrescar() {
    // bool para spinner de cargar pantalla
    this.cargandoTabla = true;

    // Llamar a refrescar datatable
    this.cargarFormulario();
    this.estadoBotonService.obtenerPorIdEstadoHabilitado( this.estado.idEstado )
      .subscribe( res => {
        this.estadosBotones = res;
        this.botonesFiltrados = this.botones.filter( x => this.estadosBotones.find( y => y.idBoton === x.value ) === undefined );
        this.cargandoTabla = false;
        this.carInformacionInicial = false;
      } );
  }

  atras() {
    this.location.back();
  }

}
